<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="line-clamp-none break-all lg:line-clamp-3">
                {{ props.modelValue.name || '-' }}
            </div>
        </vx-table-row-title>

        <vx-table-row-buttons>
            <vx-button :href="`/settings/teams/${props.modelValue.team_id}/group-collections/${props.modelValue.id}`"
                color="muted"
                outline data-test="go-tocollection-btn">
                Go to Collection <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"/>
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>
<script setup>
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { faSquareArrowUpRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});
</script>
